// Ordered page content for the Leads setup tutorial.
// Each step maps a visual variant to a concise title + 3-5 bullets.
// Kept short on purpose — the modal frame never scrolls.

const STEPS = [
  {
    id: "welcome",
    title: "Welcome to Leads",
    subtitle: "A three-pane workspace for outbound and follow-ups.",
    visual: "welcome",
    highlight: "center",
    bullets: [
      "Left rail: campaigns, smart views, and quick actions.",
      "Center: the active view — Today, Queue, Follow-ups, Replies, or All leads.",
      "Right drawer: the focused lead with thread, composer, notes, and activity.",
      "Tracking is off by design — only real host replies count as engagement.",
    ],
  },
  {
    id: "gmail",
    title: "Connect Gmail and set your signature",
    subtitle: "Outbound sends and inbound replies both route through your mailbox.",
    visual: "gmail",
    bullets: [
      "If the amber banner is showing, Gmail is not connected yet — click Connect Gmail.",
      "Grant send + read scopes so the workspace can send emails and pull replies.",
      "In Settings → Email signature, paste the HTML of your Gmail signature and Save.",
      "That signature is appended to every send; the backend's auto-generator is disabled.",
      "Tip: keep it simple text — no images, no tracking pixels, no marketing banners.",
    ],
    cta: null,
  },
  {
    id: "campaign",
    title: "Create your first campaign",
    subtitle: "Each campaign is one outbound initiative with its own sequence.",
    visual: "campaign",
    highlight: "rail",
    bullets: [
      "In the left rail, use the New Campaign form at the top.",
      "Give it a name and a short brief — this anchors every follow-up.",
      "Click + New to show the form again later if you close it.",
      "Tracking toggles are intentionally absent. Engagement = host reply.",
    ],
  },
  {
    id: "sequence",
    title: "Sequence, timing, merge vars",
    subtitle: "Open Settings on a campaign to edit its sequence steps.",
    visual: "sequence",
    bullets: [
      "Each step has a delay (days), a Send at time, subject, and HTML body.",
      "Use {{first_name|there}} for merge variables. The text after | is the fallback.",
      "Steps warn inline when a variable has no fallback — tap Preview to see a rendered example.",
      "Skip weekends treats delays as business days and rolls Sat/Sun sends to Monday.",
      "Use Insert signature per step, and edit the Unsubscribe line in the sidebar.",
    ],
  },
  {
    id: "csv",
    title: "Import a lead list",
    subtitle: "A 5-step wizard that maps, validates, and commits.",
    visual: "csv",
    bullets: [
      "Upload → Columns → Mapping → Validate → Review.",
      "We auto-detect email, URL, and phone columns; adjust mappings as needed.",
      "Rows with invalid emails or missing required fields are flagged — not silently dropped.",
      "The Review step shows new vs. updates vs. skipped before you commit.",
    ],
  },
  {
    id: "views",
    title: "Today and smart views",
    subtitle: "Hit 1–5 in the rail to switch views instantly.",
    visual: "smartViews",
    bullets: [
      "1 — Today: everything due right now, grouped by type.",
      "2 — Replies: unread host replies, newest first.",
      "3 — Follow-ups: what needs your touch, with a why for each row.",
      "4 — Queue: pending outbound sends you can ship, skip, or regenerate.",
      "5 — All leads: the full ledger, filterable and searchable.",
    ],
  },
  {
    id: "drawer",
    title: "Drawer and hotkeys",
    subtitle: "Click any row to open the detail drawer on the right.",
    visual: "drawer",
    highlight: "drawer",
    bullets: [
      "j / k or ↓ / ↑ to move between rows without touching the mouse.",
      "Enter opens, Esc closes the drawer.",
      "/ focuses the search field, ? reopens this tutorial.",
      "Inside the drawer: next action, thread, composer, contacts, notes, activity.",
      "Snooze a follow-up from its row or the drawer with presets + custom date.",
    ],
  },
];

export default STEPS;
